import { actions } from '@/modules/Intervention/store/actions';
import { getters } from '@/modules/Intervention/store/getters';
import { mutations } from '@/modules/Intervention/store/mutations';
import { DemandeInterventionState, state } from '@/modules/Intervention/store/state';
import { RootState } from '@/plugins/store';
import { Module } from 'vuex';
import equipement, { EquipementState } from './modules/Equipement';
import types, { TypeState } from './modules/Types';

export interface InterventionModuleState extends DemandeInterventionState {
    equipementModule: EquipementState,
    typeModule: TypeState,
}

const module: Module<DemandeInterventionState, RootState> = {
    modules: {
        equipementModule: equipement,
        typeModule: types,
    },
    state,
    mutations,
    actions,
    getters,
};

export default module;
export type { DemandeInterventionState };

